class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      await this.request('add', data);
      const response = await this.request('get');
      this.cart = response;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const responseData  = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async change(data) {
    try {
      const responseData  = await this.request('change', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {
      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      console.log("DATA ITEMS:")
      console.log(data.items)
      data.items.forEach((item) => {
        console.log("this.cart.items:")
        console.log(this.cart.items)
        let index = this.cart.items.findIndex(e => e.id === item.id);
        
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      const cart_tabs = document.querySelectorAll('.cart-tabs .cart-tab');
      const cart_content = document.querySelector('.basket-cart');
      const saved_content = document.querySelector('.saved-cart');
      const quickview = document.querySelector('.quick-view-container');

      if (quickview) {
        quickview.classList.remove('active');
      }

      cart_content.style.display = 'flex';
      saved_content.style.display = 'none';

      cart_tabs[0].classList.add('active');
      cart_tabs[1].classList.remove('active');

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector('.side-cart-recommended').classList.add('open');
        this.dispatchEvent("side_cart_opened", false);
      }

      window.globalListeners.hideEmptyCardReview();
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector('.side-cart-recommended').classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  async reRenderSideCart(successCallback = null) {
    // UPDATE CART COUNT
    const updateCartCount = () => {
      const cart = document.querySelector('#cart-drawer-container .inner .cart');
      let cart_count = cart.getAttribute('data-items-count');
      const cartCountEl = document.querySelectorAll(".cart-count");
      const cartBtnEl = document.querySelector('.basket.openSideCart');

      if ( cartBtnEl && cartCountEl && cart && cart_count ) {
        
        cartCountEl.forEach(count_el => {
          if ( cart_count == 0 ) {
            count_el.classList.add('empty-cart');
            cartBtnEl.classList.add('empty-cart');
          } else {
            count_el.classList.remove('empty-cart');
            cartBtnEl.classList.remove('empty-cart');
          }
          count_el.innerHTML = cart_count;
        });
        // console.log('CART COUNT EL:', cartCountEl, 'COUNT: ', cart_count);
      }
    }
    
    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=gt-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["gt-side-cart"];

      const side_cart_inner = document.querySelector("#cart-drawer-container .inner");
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
        
        updateCartCount();
        window.restrictedShipping.checkCartItems();
        window.wishlist.initSideCartGrid();
        // const free_delivery_el = document.querySelector('.free-delivery-status');
        // const free_delivery_trigger = free_delivery_el.dataset.freeDelivery;
        // const money_format = free_delivery_el.dataset.moneyFormat;
        const cart_total = document.querySelector('#cart-drawer .sub-total').dataset.subTotal / 100;

        // if (!free_delivery_trigger) {
        //   free_delivery_el.style.display = 'none';
        // } else if (cart_total < free_delivery_trigger) {
        //   const spend_more = (free_delivery_trigger - cart_total).toFixed(2);
        //   free_delivery_el.innerHTML = `${money_format + spend_more} away from free delivery`;
        // } else {
        //   free_delivery_el.innerHTML = `Yay! You've qualified for free delivery! 🎉`;
        // }

        let first_cart_item = side_cart_inner.querySelector('.item');
        if (first_cart_item) {
          first_cart_item = first_cart_item.dataset.productId;
        }

        if (first_cart_item) {
          const productRecommendationsSection = document.querySelector('.cart-recommendations');
          const section_id = productRecommendationsSection.dataset.sectionId;
          const recommendationsUrl = `/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`;

          const recommendationsResponse = await fetch(recommendationsUrl);
          if (recommendationsResponse.ok) {
            const recommendationsText = await recommendationsResponse.text();
            const recommendationsHtml = document.createElement('div');
            recommendationsHtml.innerHTML = recommendationsText;
            const recommendations = recommendationsHtml.querySelector('.cart-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              const product_links = productRecommendationsSection.querySelectorAll('.product-link');
              product_links.forEach((product_link) => {
                product_link.innerHTML = "View";
              });

              new window.swiper('.side-cart-recommendations-slider', {
                slidesPerView: 2.2,
                spaceBetween: 15,
                breakpoints: {
                  400: {
                    slidesPerView: 2.2,
                    spaceBetween: 15,
                  },
                  1200: {
                    slidesPerView: 3.2
                  }
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
              });
            }
          } else {
            throw new Error("Error: " + recommendationsResponse.status);
          }
        }

        if (window.innerWidth > 767.98) {
          if (first_cart_item) {
            document.querySelector('.cart-recommendations-slider').style.display = 'none';

            const productRecommendationsSection = document.querySelector('.side-cart-product-recommendations');
            const sectionURL = productRecommendationsSection.dataset.url;
            const url = sectionURL.replace("product_id=", "product_id=" + first_cart_item);

            const sectionResponse = await fetch(url);
            if (sectionResponse.ok) {
              const sectionText = await sectionResponse.text();
              const sectionHtml = document.querySelector('.side-cart-recommended-container');
              sectionHtml.innerHTML = sectionText;

              new window.swiper('.side-cart-recommendations-slider', {
                slidesPerView: 1.5,
                spaceBetween: 15,
                navigation: {
                  nextEl: ".swiper-button-next.cart-rec",
                  prevEl: ".swiper-button-prev.cart-rec",
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
                breakpoints: {
                  400: {
                    slidesPerView: 2.2,
                    spaceBetween: 15,
                  },
                  1134: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1500: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                  },
                },
              });
            } else {
              throw new Error("Error: " + sectionResponse.status);
            }
          } else {
            new window.swiper(".cart-recommendations-slider", {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: ".swiper-button-next.cart-rec",
                prevEl: ".swiper-button-prev.cart-rec",
              },
              lazy: {
                enabled: true,
                checkInView: false,
                loadOnTransitionStart: true,
                loadPrevNext: true,
                loadPrevNextAmount: 1
              },
              breakpoints: {
                1134: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1500: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              },
            });
          }
        }
        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  reRenderCart() {
    fetch(window.Shopify.routes.root + "cart?sections=gt-cart")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        let html = data["gt-cart"];
        let cart_inner = document.querySelector("#cart-container");
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(html);
          window.restrictedShipping.checkCartItems();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }
}

// export default new CartQf();
window.CartQf = CartQf;
